import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { Airline } from 'src/app/shared/shared.models';

import { AirlineSettingsService } from '../airline-settings.service';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatInput, MatPrefix, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'app-e-rate-sheet',
    templateUrl: './e-rate-sheet.component.html',
    styleUrls: ['./e-rate-sheet.component.scss'],
    imports: [MatDivider, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatPrefix, MatIconButton, MatSuffix, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class ERateSheetComponent implements OnInit {
  @ViewChild('paginator') paginator;
  constructor(
    private route: ActivatedRoute,
    private airlineService: AirlineSettingsService,
    private spinnerService: SpinnerService,
    private snackbarService: SnackbarService
  ) { }

  private sub: any;
  id: number;
  airline: Airline;

  displayedColumns: string[] = [
    /*'uld_name',
    'carrier_code',
    'origin_country_code',
    'dgr',
    'currency_code',
    'uld_pivot_rate',
    'uld_over_pivot_rate',
    'destination_city_code',
    'effective_from',
    'effective_to',
    'country_designator',
    'collect_rate',
    'new_change',
    'uld_pivot_weight',
    'cass_no',
    'uld_flat_price',
    'origin_airport_code',
    'iata_no',
    'destination_city_name',
    'carrier_code',
    'prepaid_rate',*/
    'destination_airport_code',
    'destination_country_iso_code',
    'carrier_prefix',
    'gsa_name',
    'product_name',
    'minimum_rate',
    'normal_flat_rate',
    '45_kg',
    '100_kg',
    '150_kg',
    '300_kg',
    '500_kg',
    '1000_kg',
    'notes',
  ];

  dataSource = new MatTableDataSource([]);

  searchForm: UntypedFormGroup;
  ngOnInit(): void {
    this.sub = this.route.params.subscribe((params) => {
      this.id = +params['id']; // (+) converts string 'id' to a number
    });
    this.getAirline();

    this.searchForm = new UntypedFormGroup({
      filter: new UntypedFormControl(''),
    });
  }

  getAirline(): void {
    this.spinnerService.startSpinner();
    this.airlineService.getAirlineById(this.id).subscribe(
      (data: Airline) => {
        this.airline = data;
        const tabledata: any[] = [];

        if (this.airline.erateSheet?.sheet) {
          Object.keys(this.airline.erateSheet.sheet).forEach((key) => {
            tabledata.push(this.airline.erateSheet.sheet[key]);
          });
          this.dataSource = new MatTableDataSource(tabledata);
          this.dataSource.paginator = this.paginator;

          this.spinnerService.stopSpinner();
        } else {
          this.spinnerService.stopSpinner();
          this.snackbarService.openErrorMessage('There currently is no eratesheet.');
        }
      },

      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  // -- search --

  clearSearch(): void {
    this.searchForm.controls['filter'].setValue('');
    this.applyFilter();
  }

  applyFilter(): void {
    const filterValue = this.searchForm.value.filter;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
